"use strict";
exports.__esModule = true;
exports.GdcCatalog = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
/**
 *
 * @public
 */
var GdcCatalog;
(function (GdcCatalog) {
    function isCatalogAttribute(obj) {
        return !isEmpty_1["default"](obj) && obj.type === "attribute";
    }
    GdcCatalog.isCatalogAttribute = isCatalogAttribute;
    function isCatalogMetric(obj) {
        return !isEmpty_1["default"](obj) && obj.type === "metric";
    }
    GdcCatalog.isCatalogMetric = isCatalogMetric;
    function isCatalogFact(obj) {
        return !isEmpty_1["default"](obj) && obj.type === "fact";
    }
    GdcCatalog.isCatalogFact = isCatalogFact;
})(GdcCatalog = exports.GdcCatalog || (exports.GdcCatalog = {}));
//# sourceMappingURL=GdcCatalog.js.map